import {Calendar, Empty, Col, Row, Button, Tag, Table, Modal, Popconfirm} from "antd";
import moment from "moment";
import React, {useState, useContext, Fragment, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {ShiftRequestContext} from "../ShiftRequest";
import "moment/locale/tr";
import {calendarLocales} from "../../../constants/calendar";
import {shiftStatusColors} from "../../../constants/shift";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";
moment.locale("tr");

export const ShiftRequestCalendar = () => {
    const {i18n, t} = useTranslation(["shiftRequest"]);

    const {
        selectedCompany,
        selectedSubCompany,
        shiftRequests,
        selectedShiftDay,
        onPanelChange,
        handleOnDaySelect,
        isShiftModalOpen,
        setShiftIsModalOpen,
        handleDeleteShiftRequest,
        setSelectedShiftRequest,
        setIsCreateModalOpen,
        setIsShiftRequestUpdating
    } = useContext(ShiftRequestContext);

    const [deleteConfirmMap, setDeleteConfirmMap] = useState({});

    const toggleDeleteConfirm = (recordId, visible) => {
        setDeleteConfirmMap(prev => ({
            ...prev,
            [recordId]: visible
        }));
    };

    const handleModalClose = () => {
        setDeleteConfirmMap({});
        setTimeout(() => {
            setShiftIsModalOpen(false);
        }, 0);
    };

    if (!selectedSubCompany || !selectedCompany) {
        return (
            <Col span={24}>
                <EmptyMessage descriptionKey="needCompany" ns="shiftRequest" />
            </Col>
        );
    }

    const dataCellRender = value => {
        const dayShifts = Object.keys(shiftRequests)
            .filter(key => moment(key).isSame(value, "day"))
            .flatMap(key => shiftRequests[key]);

        if (dayShifts.length === 0) {
            return null;
        }

        return (
            <Row onClick={() => handleOnDaySelect(value)} gutter={[4, 4]}>
                {dayShifts.slice(0, 3).map((shift, index) => (
                    <Col span={24} key={index.toString()}>
                        <Tag color="blue">
                            {shift.startTime.substring(0, shift.startTime.length - 3)} -{" "}
                            {shift.endTime.substring(0, shift.endTime.length - 3)}
                        </Tag>
                    </Col>
                ))}
            </Row>
        );
    };

    return (
        <Fragment>
            <Col span={24}>
                <Calendar
                    fullscreen
                    defaultValue={moment()}
                    onPanelChange={onPanelChange}
                    dateCellRender={dataCellRender}
                    locale={calendarLocales[i18n.resolvedLanguage ?? "tr"] ?? calendarLocales.tr}
                />
            </Col>
            <Modal
                visible={isShiftModalOpen}
                onCancel={handleModalClose}
                onOk={handleModalClose}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
                title={`${t("shiftDetails.title", {ns: "shiftRequest"})} - ${moment(
                    selectedShiftDay
                ).format("DD/MM/YYYY")}`}
                width={800}
            >
                <Table
                    dataSource={shiftRequests[selectedShiftDay]}
                    pagination={false}
                    columns={[
                        {
                            title: t("shiftDetails.shiftTime", {ns: "shiftRequest"}),
                            dataIndex: "startTime",
                            key: "startTime",
                            render: (text, record) => (
                                <span>
                                    {record.startTime.substring(0, record.startTime.length - 3)} -{" "}
                                    {record.endTime.substring(0, record.endTime.length - 3)}
                                </span>
                            )
                        },
                        {
                            title: t("shiftDetails.courierCount", {ns: "shiftRequest"}),
                            dataIndex: "personCount",
                            key: "personCount"
                        },
                        {
                            title: t("shiftDetails.status.title", {ns: "shiftRequest"}),
                            dataIndex: "status",
                            key: "status",
                            render: (text, record) => {
                                const color = shiftStatusColors[record.status];
                                return (
                                    <Tag color={color} key={record.status}>
                                        {t(`shiftDetails.status.${record.status}`, {
                                            ns: "shiftRequest"
                                        })}
                                    </Tag>
                                );
                            }
                        },
                        {
                            title: t("actions.action", {ns: "common"}),
                            key: "actions",
                            render: (text, record) => (
                                <Row gutter={[5, 5]}>
                                    <Col>
                                        <Button
                                            onClick={() => {
                                                setIsShiftRequestUpdating(true);
                                                setSelectedShiftRequest(record);
                                                setShiftIsModalOpen(false);
                                                setTimeout(() => {
                                                    setIsCreateModalOpen(true);
                                                }, 0);
                                            }}
                                        >
                                            {t("actions.update", {ns: "common"})}
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                setSelectedShiftRequest(record);
                                                setShiftIsModalOpen(false);
                                                setIsCreateModalOpen(true);
                                            }}
                                        >
                                            {t("actions.copyShift", {ns: "shiftRequest"})}
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Popconfirm
                                            visible={deleteConfirmMap[record._id]}
                                            title={t("modal.confirmTitle", {ns: "common"})}
                                            cancelText={t("modal.cancelButton", {ns: "common"})}
                                            onCancel={() => toggleDeleteConfirm(record._id, false)}
                                            okText={t("modal.yesButton", {ns: "common"})}
                                            onConfirm={() => {
                                                handleDeleteShiftRequest(record._id);
                                                toggleDeleteConfirm(record._id, false);
                                            }}
                                        >
                                            <Button
                                                type="primary"
                                                onClick={() =>
                                                    toggleDeleteConfirm(record._id, true)
                                                }
                                                danger
                                            >
                                                {t("actions.delete", {ns: "common"})}
                                            </Button>
                                        </Popconfirm>
                                    </Col>
                                </Row>
                            )
                        }
                    ]}
                    expandedRowRender={record => <p style={{margin: 0}}>{record.shiftNote}</p>}
                />
            </Modal>
        </Fragment>
    );
};

export default ShiftRequestCalendar;
